import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  required,
  TabbedForm,
  Edit,
  DisabledInput,
  FormTab,
  ReferenceManyField,
  Pagination,
  EditButton,
  EmailField,
  BooleanField,
} from "react-admin";

import {
  ClinicNameField,
  DoctorReferenceField,
  PatientReferenceField,
  ClinicReferenceField,
} from "../../misc/customFields";
import SendClinicInvitationButton from "./SendEmailButton";

export const ClinicList = (props) => {
  return (
    <div>
      <List {...props} title="Clinics">
        <Datagrid>
          <ClinicReferenceField label="Clinic" />
          <TextField source="id" />
          <TextField source="name" />
          <DoctorReferenceField label="Owner" source="owner" sortable={false} />
          <DateField source="created" />
          <NumberField
            source="members_count"
            label="Members"
            sortable={false}
          />
          <NumberField
            source="patients_count"
            label="Patients"
            sortable={false}
          />
        </Datagrid>
      </List>
    </div>
  );
};

export const ClinicCreate = (props) => {
  return (
    <Create {...props} title="Create Clinic">
      <SimpleForm>
        <TextInput source="name" validate={required()} />
        <ReferenceInput
          label="Owner"
          source="owner"
          reference="doctors"
          validate={required()}
        >
          <SelectInput optionText="email" />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

export const TabledClinicEdit = (props) => {
  return (
    <Edit title={<ClinicNameField />} {...props}>
      <TabbedForm>
        <FormTab label="Clinic">
          <DisabledInput label="Id" source="id" />
          <DateField label="Creation date" source="created" />
          <TextInput source="name" validate={required()} />
          <ReferenceInput
            label="Owner"
            source="owner"
            reference="doctors"
            validate={required()}
          >
            <SelectInput optionText="email" />
          </ReferenceInput>
          <DisabledInput source="members_count" label="Members" />
          <DisabledInput source="patients_count" label="Patients" />
        </FormTab>
        <FormTab label="Members">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "joined", order: "DESC" }}
            reference="clinic_members"
            target="clinic"
            pagination={<Pagination />}
          >
            <Datagrid>
              <TextField source="id" label="Member ID" />
              <DoctorReferenceField source="doctor" />
              <DoctorReferenceField source="host" label="Host" />
              <BooleanField source="is_owner" label="Owner" />
              <DateField source="joined" label="Joined" />
              <NumberField source="member_number" label="Member Number" />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
        <FormTab label="Invitations">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "created", order: "DESC" }}
            reference="clinic_invites"
            target="clinic"
            pagination={<Pagination />}
          >
            <Datagrid>
              <TextField source="id" />
              <DoctorReferenceField source="doctor" />
              <DoctorReferenceField source="host" label="Host" />
              <DateField source="joined" label="created" />
              <SendClinicInvitationButton disabled={false} />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
        <FormTab label="Patients">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "id", order: "DESC" }}
            reference="patients"
            target="clinic"
            pagination={<Pagination />}
          >
            <Datagrid>
              <TextField source="id" />
              <PatientReferenceField label="Patient" />
              <EmailField source="email" />
              <TextField source="gender" />
              <TextField source="phone_number" />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
